var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitoringDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6667 0H2.33333C1.05 0 0 1.05 0 2.33333V18.6667C0 19.95 1.05 21 2.33333 21H18.6667C19.95 21 21 19.95 21 18.6667V2.33333C21 1.05 19.95 0 18.6667 0ZM5.83333 16.3333C5.19167 16.3333 4.66667 15.8083 4.66667 15.1667V11.6667C4.66667 11.025 5.19167 10.5 5.83333 10.5C6.475 10.5 7 11.025 7 11.6667V15.1667C7 15.8083 6.475 16.3333 5.83333 16.3333ZM9.33333 15.1667C9.33333 15.8083 9.85833 16.3333 10.5 16.3333C11.1417 16.3333 11.6667 15.8083 11.6667 15.1667V14C11.6667 13.3583 11.1417 12.8333 10.5 12.8333C9.85833 12.8333 9.33333 13.3583 9.33333 14V15.1667ZM10.5 10.5C9.85833 10.5 9.33333 9.975 9.33333 9.33333C9.33333 8.69167 9.85833 8.16667 10.5 8.16667C11.1417 8.16667 11.6667 8.69167 11.6667 9.33333C11.6667 9.975 11.1417 10.5 10.5 10.5ZM14 15.1667C14 15.8083 14.525 16.3333 15.1667 16.3333C15.8083 16.3333 16.3333 15.8083 16.3333 15.1667V5.83333C16.3333 5.19167 15.8083 4.66667 15.1667 4.66667C14.525 4.66667 14 5.19167 14 5.83333V15.1667Z",
    fill: "#B9C1C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitoringDark);
export default __webpack_public_path__ + "static/media/monitoring-dark.a095c10a88eda5ad4b380ed8687dc34f.svg";
export { ForwardRef as ReactComponent };